<div class="row">
    <div class="col-12 ms-2" *ngIf="(financeContracts && financeContracts?.length > 0) || (mode == 'payouts')">
        <p class="f-c-p-7 mt-5">
            Payouts from  <span class="notranslate">{{ startDate | date }} - {{ endDate | date }}</span>
        </p>
        <div>
            <button *ngIf="mode == 'payouts' " button-primary-auth type="submit" (click)="getPaymentReportsV2(token,startDate,endDate,1)">Export Report</button>
            <button *ngIf="mode == 'contracts' " button-primary-auth type="submit" (click)="getContractsReport(token,startDate,endDate,2)">Export Report</button>
        </div>
    </div>

    <div class="col-12 mt-5 ms-2" *ngIf="financeContracts && financeContracts.length == 0">
        No contract created in this time period
    </div>
</div>